<template>
    <RecommendedItem 
        v-if="items.length > 0"
        :title="$t('LandingPage.recommended_items_sign_up_for_digital_classrooms_title')"
        :button-label="$t('General.see_all')"
        @buttonClick="$router.push({name:'all-packages-virtual-classrooms'})"
    >
        <CarouselCourses theme="dark" :courses="items" />
    </RecommendedItem>
</template>

<script>
    import RecommendedItem from 'components/landingpage/RecommendedItem'
    import CarouselCourses from 'components/user/summary/carousel/CarouselCourses'
    import { mapGetters } from 'vuex'
    import withLanguage from 'components/landingpage/recommended-items/mixins/with-language'

    export default {
        components: { CarouselCourses, RecommendedItem },
        computed: {
            ...mapGetters({
                items: 'Courses/getUpcomingDigitalClassrooms'
            })
        },
        data () {
            return {
                storeUpdateContentAction: 'Courses/loadUpcomingDigitalClassrooms'
            }
        },
        mixins: [withLanguage]
    }
</script>
